/**
 * Added by - Ashlekh on 08-04-2025
 * Reason - To add Member page
 */

// import { Box, Button, TextField, Typography } from "@mui/material";
import { Modal } from "antd";
import parse from "html-react-parser";
import { useContext, useEffect, useState } from "react";
import "react-multi-carousel/lib/styles.css";
import { Link } from "react-router-dom";
import config from "../../Api/config";
import {
  getMemberDetailsAPI,
  memberRegistrationDetailsAPI,
} from "../../Api/services";
import NavigationPath from "../../components/NavigationPath/NavigationPath";
import { GlobalContext } from "../../context/Context";
import style from "./Member.module.css";

import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";

const Member = () => {
  const { navigationPath, setNavigationPath } = useContext(GlobalContext);
  const [showContent, setShowContent] = useState(false);
  const [pageContent, setPageContent] = useState({});
  const [formData, setFormData] = useState({
    name: "",
    mobile_number: "",
    email: "",
    occupation: "",
    // profile_image: null,
    // Added by - Ashlekh on 19-04-2025
    // Reason - To add recommended by & address options
    recommended_by: "",
    address: "",
    // End of code - Ashlekh on 19-04-2025
    // Reason - To add recommended by & address options
  });
  const [errors, setErrors] = useState({});
  const [wardDetails, setWardDetails] = useState([]);
 
  const [pdfUrl, setPdfUrl] = useState(null);

  const [governingBodies, setGoverningBodies] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  // Added by - Ashlekh on 16-05-2025
  // Reason - To set member form
  const [memberForm, setMemberForm] = useState(null);
  // End of code - Ashlekh on 16-05-2025
  // Reason - To set member form
  // Added by - Yogen on 14-06-2025
  // Reason - To set ward name of life member
  const [wardName, setWardName] = useState([]);
  // End of code - Yogen on 14-06-2025
  // Reason - To set ward name of life member
  // Added by - Yogen on 15-06-2025
  // Reason - To set previous committee details
  const [previousCommittee, setPreviousCommittee] = useState([]);
  // Ended by - Yogen on 15-06-2025
  // Reason - To set previous committee details
  // Added by - Ashlekh on 08-04-2025
  // Reason - This useEffect will execute when page loads
  useEffect(() => {
    setNavigationPath([
      { name: "Home", path: "/" },
      { name: "Member", path: "/member" },
    ]);
    window.scrollTo(0, 0);
    getMemberDetails();
  }, []);
  // End of code - Ashlekh on 08-04-2025
  // Reason - This useEffect will executes when page loads

  // Added by - Ashlekh on 08-04-2025
  // Reason - To get details from backend
  const getMemberDetails = async () => {
    try {
      const response = await getMemberDetailsAPI();
      setPageContent(response?.member);
      setWardDetails(response?.ward_details);
      setGoverningBodies(response?.governing_bodies);
      // Added by - Ashlekh on 12-06-2025
      // Reason - To add member form in useState
      setMemberForm(response?.member?.member_form);
      // End of code - Ashlekh on 12-06-2025
      // Reason - To add member form in useState
      // Added by - Yogen on 14-06-2025
      // Reason - To add for set the ward name of life members
      setWardName(response?.life_member_ward_name);
      // End of code - Yogen on 14-06-2025
      // Reason - To add for set the ward name of life members
      // Added by - Yogen on 15-06-2025
      // Reason - To add for set the previous committee details
      setPreviousCommittee(response?.previous_committee_members);
      // End of code - Yogen on 15-06-2025
      // Reason - To add for set the previous committee details
    } catch (error) {
      console.error("Error fetching details:", error);
    } finally {
      setShowContent(true);
    }
  };
  // End of code - Ashlekh on 08-04-2025
  // Reason - To get details from backend

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    const payload = new FormData();
    payload.append("name", formData.name);
    payload.append("mobile_number", formData.mobile_number);
    payload.append("email", formData.email || "");
    payload.append("occupation", formData.occupation);
    // Added by - Ashlekh on 19-04-2025
    // Reason - To add recommended by & address options
    payload.append("recommended_by", formData.recommended_by);
    payload.append("address", formData.address);
    // End of code - Ashlekh on 19-04-2025
    // Reason - To add recommended by & address options
    // if (formData.profile_image) {
    //   payload.append("profile_image", formData.profile_image);
    // }
    try {
      const response = await memberRegistrationDetailsAPI(payload);
      if (response?.message) {
        // notificationObject.success("Submitted Successfully");
        setFormData({
          name: "",
          mobile_number: "",
          email: "",
          occupation: "",
          // profile_image: null,
        });
        window.scrollTo({ top: 0, behavior: "smooth" });
        setErrors({});
      }
    } catch (error) {
      console.error("Error during submission:", error);
      //   notificationObject.error("Something went wrong. Please try again.");
    }
  };

  const validate = () => {
    const newErrors = {};
    const nameRegex = /^[A-Za-z\s]+$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const contactNumberRegex = /^[1-9]\d{9}$/;

    if (!formData.name) {
      newErrors.name = "Please enter name.";
    } else if (!nameRegex.test(formData.name)) {
      newErrors.name = "Only alphabets are allowed";
    }

    if (!formData.mobile_number) {
      newErrors.mobile_number = "Please Enter mobile number";
    } else if (!contactNumberRegex.test(formData.mobile_number.trim())) {
      newErrors.mobile_number = "Please enter valid mobile number.";
    }

    if (!formData.occupation) {
      newErrors.occupation = "Please enter your present occupation.";
    }
    if (formData.email && !emailRegex.test(formData.email.trim())) {
      newErrors.email = "Please enter a valid email address.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({
        ...prev,
        profile_image: file,
      }));
    }
  };

  const showModal = (item) => {
    setSelectedItem(item);
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setSelectedItem(null);
  };

  const governingBodiesResponsive = {
    // superLargeDesktop: {
    //   // the naming can be any, depends on you.
    //   breakpoint: { max: 4000, min: 3000 },
    //   items: 5
    // },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
      slidesToSlide: 1,
    },
    tablet2: {
      breakpoint: { max: 1124, min: 873 },
      items: 3,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 872, min: 465 },
      items: 2,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  return (
    <div>
      {showContent ? (
        <div className={`${style.mainContainer}`}>
          {/* Commented  By - Yogen on 30-06-2025
          Reason - for remove this section  */}
          {/* {pageContent?.image ? (
            <div className={`${style.bannerImage}`}>
              <img
                className={`${style.image}`}
                src={config.baseURL + pageContent?.image}
                alt=""
              />
            </div>
          ) : null} */}
          {/* Ended  By - Yogen on 30-06-2025
          Reason - for remove this section  */}

          <NavigationPath navigationPathArray={navigationPath} />
          {pageContent?.description || pageContent?.description?.length > 0 ? (
            <div className={`${style.pageTitle}`}>Member</div>
          ) : (
            <p className={style.noDetailsAvailableText}>No details Available</p>
          )}
          {pageContent?.description ? (
            <div className={`${style.description}`}>
              {" "}
              {parse(pageContent?.description)}{" "}
            </div>
          ) : null}

          {/* Added by - Ashlekh on 29-04-2025
          Reason - To display governing bodies */}
          {governingBodies?.length > 0 && (
            <div className={`${style.governingBodiesTitle}`}>
              Governing Bodies
            </div>
          )}
          {/* {governingBodies?.map((item, index) => {
            return (
              <div
                key={index}
                // style={{
                //   backgroundImage:
                //     "url(" + baseURL + item.background_image + ")",
                // }}
                className={`${style.memberPageGoverningBodiesImageAndDescriptionContainer}`}
              >
                {window.innerWidth >= 720 ? (
                  <div
                    className={`${style.memberPageGoverningBodiesImageAndDescriptionSubContainer}`}
                  >
                    <img
                      className={`${style.memberPageGoverningBodiesImage}`}
                      src={config.baseURL + item?.image}
                      alt=""
                      style={{ order: index % 2 == 0 ? 0 : 1 }}
                    />
                    <div
                      className={`${style.memberPageGoverningBodiesDescriptionContainer}`}
                      style={{ order: index % 2 == 0 ? 1 : 0 }}
                    >
                      <div className={`${style.governingBodiesName}`}>
                        {item?.name}
                      </div>
                      <div className={`${style.governingBodiesDesignation}`}>
                        {item?.designation}
                      </div>
                      <div
                        className={`${style.memberPageGoverningBodiesDescription}`}
                      >
                        {parse(
                          item?.detail?.slice(0, 200) +
                            (item?.detail?.length > 200 ? "..." : "")
                        )}
                      </div>
                      {item?.detail && (
                        <div className={`${style.readMoreContainer}`}>
                          <div
                            className={`${style.readMore}`}
                            onClick={() => showModal(item)}
                          >
                            Read More
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <div
                    className={`${style.memberPageGoverningBodiesImageAndDescriptionContainer}`}
                  >
                    <img
                      className={`${style.memberPageGoverningBodiesImage}`}
                      src={config.baseURL + item?.image}
                      alt=""
                    />
                    <div
                      className={`${style.memberPageGoverningBodiesDescriptionContainer}`}
                    >
                      <div
                        className={`${style.memberPageGoverningBodiesDescription}`}
                      >
                        {parse(
                          item?.detail?.slice(0, 200) +
                            (item?.detail?.length > 200 ? "..." : "")
                        )}
                      </div>
                      {item?.detail && (
                        <div className={`${style.readMoreContainer}`}>
                          <div
                            className={`${style.readMore}`}
                            onClick={() => showModal(item)}
                          >
                            Read More
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            );
          })} */}

          {/* Added by Ashlekh on 04/06/2025 
          Reason To have Governing bodies with carousal */}
          {/* {governingBodies?.length > 0 && (
            <div className={`${style.governingBodiesParentContainer}`}>
              <Carousel responsive={governingBodiesResponsive}>
                {governingBodies?.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className={`${style.governingBodiesContainer}`}
                    >
                      <div
                        className={`${style.governingBodiesSubContainer} ${
                          index % 2 == 0 ? style.even : style.odd
                        }`}
                      >
                        <div
                          className={`${style.governingBodiesCarouselContainer}`}
                        >
                          <img
                            className={`${style.governingBodiesCarouselImage}`}
                            // src={`${config.baseURL}${item.image}`}
                            src={
                              item.image != null &&
                              item.image.trim() != "" &&
                              item?.image?.length > 1
                                ? `${config.baseURL}${item.image}`
                                : `${``}`
                            }
                            alt=""
                          />
                        </div>
                        <div
                          className={`${style.memberNameAndDesignation} ${style.governingBodiesName}`}
                        >
                          {item?.name?.length > 30
                            ? item?.name?.slice(0, 30) + "..."
                            : item?.name}
                        </div>
                        <p className={`${style.memberNameAndDesignation}`}>
                          {item?.designation?.length > 30
                            ? item?.designation?.slice(0, 30) + "..."
                            : item?.designation}
                        </p>
                        {item?.detail && (
                          <div className={`${style.readMoreContainer}`}>
                            <div
                              className={`${style.readMore}`}
                              onClick={() => showModal(item)}
                            >
                              Read More
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </Carousel>
            </div>
          )} */}

          {/* End of code Addition by Ashlekh on 04/06/2025 
           Reason To have governing bodies with carousal  */}

          {/* Added by - Yogen  on 15-05-2025
              Reason - To add for display the details of the governing bodies  */}

          {/* {governingBodies?.length > 0 && (
            <div className={`${style.memberDetails}`}>Governing Bodies</div>
          )} */}
          <div className={style.container}>
            {governingBodies.map((card, index) => (
              <div
                key={index}
                className={style.card}
                style={{ borderBottomColor: card.borderColor }}
              >
                <div
                  className={`${style.cardInner} ${
                    index % 2 == 0 ? style.even : style.odd
                  }`}
                >
                  {card.image && (
                    <img
                      src={`${config.baseURL}/${card.image}`}
                      alt={card.alt}
                      className={style.image}
                    />
                  )}
                  {card.name && (
                    <div className={style.governingBodiesName}>{card.name}</div>
                  )}

                  {card.designation && (
                    <div className={style.governingBodiesDesignation}>
                      {card.designation}
                    </div>
                  )}
                  {card.registration_number && (
                    <div className={style.governingBodiesDesignation}>
                      {card.registration_number}
                    </div>
                  )}
                  {/* {card.contact_number && (
                    <h3 className={style.contactNumber}>
                      {card.contact_number}
                    </h3>
                  )} */}
                  {/* {card.detail && (
                    <div className={style.governingBodiesDetails}>
                      {parse(card?.detail)}                
                    </div>
                  )} */}
                  <button
                    className={style.button}
                    onClick={() => showModal(card)}
                  >
                    Read More
                  </button>
                </div>
              </div>
            ))}
          </div>
          {/* End of code - Yogen on 15-05-2025
          Reason - To add for display the details of the governing bodies  */}

          <Modal
            open={isModalOpen}
            onCancel={handleCancel}
            footer={null}
            centered
          >
            {selectedItem && (
              <div
                className={`${style.governingBodiesImageAndDescriptionContainer}`}
              >
                <img
                  src={config.baseURL + selectedItem.image}
                  alt=""
                  className={`${style.governingBodiesImage}`}
                />
                <div className={`${style.governingBodiesName}`}>
                  {selectedItem?.name}
                </div>
                <div className={`${style.governingBodiesDesignation}`}>
                  {selectedItem?.designation}
                </div>
                {/* <div className={`${style.registrationNumber}`}>
                  Registration Number : {selectedItem?.registration_number}
                </div> */}
                {/* Added by - yogen on 03/07/2025 
                Reason - for show the ragistration number conditionally  */}
                {selectedItem?.registration_number != null &&
                  selectedItem?.registration_number?.trim()?.length > 0 && (
                    <div className={`${style.registrationNumber}`}>
                      Registration Number : {selectedItem?.registration_number}
                    </div>
                  )}
                {/* Ended by - yogen on 03/07/2025 
                Reason - for show the ragistration number conditionally  */}
                <div>{parse(selectedItem?.detail)}</div>
              </div>
            )}
          </Modal>
          {/* End of code - Ashlekh on 29-04-2025
          Reason - To display governing bodies */}

          {/* Added by - Yogen  on 09-05-2025
              Reason - To add Committee details table */}

          {/* Updated by - Yogen on 18-06-2025
              Reason - To hide the heading and table if `wardDetails` is blank */}
          {wardDetails?.length > 0 && (
            //  Ended by - Yogen on 18-06-2025
            //  Reason - To hide the heading and table if `wardDetails` is blank
            <Box my={4} fontFamily="Rubik" fontWeight="900">
              {/* {wardDetails?.length > 0 && ( */}
              <div className={`${style.wardTitle}`}>Committee details</div>
              {/* )} */}
              <TableContainer
                component={Paper}
                elevation={5}
                sx={{
                  width: "80%",
                  margin: "auto",
                }}
              >
                <Table
                  sx={{
                    "& th, & td": {
                      borderRight: "1px solid #ddd",
                    },
                    "& th:last-child, & td:last-child": {
                      borderRight: "none",
                    },
                  }}
                >
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#f2f2f2;" }}>
                      <TableCell
                        align="center"
                        sx={{
                          width: "60%",
                          fontWeight: 800,
                          padding: "10px 8px",
                        }}
                      >
                        Name
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          width: "40%",
                          fontWeight: 800,
                          padding: "10px 8px",
                        }}
                      >
                        Details
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {wardDetails.map((item, index) => (
                      <TableRow
                        key={index}
                        hover
                        sx={{
                          "&:hover td": {
                            // backgroundColor: '#7b9199',
                            color: "black",
                          },
                          // '& td': {
                          //   transition: 'background-color 0.3s ease-in-out, color 0.3s ease',
                          // },
                          // transition: "transform 0.2s ease-in-out",
                          // "&:hover": {
                          //   transform: "scale(1.02)", // slight zoom-in
                          // },
                          height: "50px", // ? smaller height
                        }}
                      >
                        <TableCell align="center" sx={{ py: 0.5 }}>
                          {item?.ward_name}
                        </TableCell>
                        <TableCell align="center" sx={{ py: 0.5 }}>
                          <Button
                            sx={{
                              backgroundColor: "#ED5009",
                              color: "white",
                              "&:hover": {
                                backgroundColor: "#ED5009",
                                transform: "scale(1.02)",
                              },
                              textTransform: "none",
                              px: 1,
                              py: 0.4,
                              fontSize: 12,
                              minHeight: "24px",
                              transition: "transform 0.2s ease-in-out",
                            }}
                            size="small"
                            component={Link}
                            to="/member_list"
                            // state={{ id: item?.id }}
                            // added by yogen on 13-06-2025
                            // reason : for passing ward name to another page
                            state={{ id: item?.id, ward_name: item?.ward_name }}
                            // Ended by yogen on 13-06-2025
                            // reason : for passing ward name to another page

                            title="View members in this ward"
                          >
                            View More
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          )}
          {/* End of code - Yogen on 09-05-2025
              Reason - To add Committee details table*/}
          {/* Added by - Yogen  on 13-06-2025
              Reason - To add for display Life members Table */}

          {/* Updated by - Yogen on 18-06-2025
              Reason - To hide the heading and table if `wardName` is blank */}
          {wardName?.length > 0 && (
            //  Ended by - Yogen on 18-06-2025
            //  Reason - To hide the heading and table if `wardName` is blank
            <Box my={4} fontFamily="Rubik" fontWeight="900">
              {/* {wardName?.length > 0 && ( */}
              <div className={`${style.wardTitle}`}>Life Members</div>
              {/* )} */}
              <TableContainer
                component={Paper}
                elevation={5}
                sx={{
                  // width: "85%",
                  width: "80%",
                  margin: "auto",
                }}
              >
                <Table
                  sx={{
                    "& th, & td": {
                      borderRight: "1px solid #ddd",
                    },
                    "& th:last-child, & td:last-child": {
                      borderRight: "none",
                    },
                  }}
                >
                  <TableHead>
                    {/* <TableRow sx={{ backgroundColor: "#ff595e" }}></TableRow> */}
                    <TableRow sx={{ backgroundColor: "#f2f2f2;" }}>
                      <TableCell
                        align="center"
                        // sx={{ width: "60%", fontWeight: 800 }}
                        sx={{
                          width: "60%",
                          fontWeight: 800,
                          padding: "10px 8px",
                        }}
                      >
                        Name
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          width: "40%",
                          fontWeight: 800,
                          padding: "10px 8px",
                        }}
                      >
                        Details
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {wardName.map((item, index) => (
                      <TableRow
                        key={index}
                        hover
                        sx={{
                          "&:hover td": {
                            // backgroundColor: '#7b9199',
                            color: "black",
                          },
                          height: "50px",
                        }}
                      >
                        <TableCell align="center" sx={{ py: 0.5 }}>
                          {item?.ward_name}
                        </TableCell>
                        <TableCell align="center" sx={{ py: 0.5 }}>
                          <Button
                            sx={{
                              backgroundColor: "#ED5009",
                              color: "white",
                              "&:hover": {
                                backgroundColor: "#ED5009",
                                transform: "scale(1.02)",
                              },
                              textTransform: "none",
                              px: 1,
                              py: 0.4,
                              fontSize: 12,
                              minHeight: "24px",
                              transition: "transform 0.2s ease-in-out",
                            }}
                            size="small"
                            component={Link}
                            to="/life_member_list"
                            state={{ id: item?.id, ward_name: item?.ward_name }}
                            title="View members in this area"
                          >
                            {/* View More */}
                            View Details
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          )}
          {/* End of code - Yogen on 03-06-2025
              Reason - To add for display Life Members table */}
          {/* Added by - Yogen  on 13-06-2025
              Reason - To add for display Previous Committee Members */}
          {/* Updated by - Yogen on 18-06-2025
              Reason - To hide the heading and table if `previousCommittee details` is blank */}
          {previousCommittee?.length > 0 && (
            //  Ended by - Yogen on 18-06-2025
            //  Reason - To hide the heading and table if `previousCommittee details` is blank
            <Box my={4} fontFamily="Rubik" fontWeight="900">
              {/* {previousCommittee?.length > 0 && ( */}
              <div className={`${style.wardTitle}`}>
                Previous Committee Members
              </div>
              {/* )} */}
              <TableContainer
                component={Paper}
                elevation={5}
                sx={{
                  width: "80%",
                  margin: "auto",
                }}
              >
                <Table
                  sx={{
                    "& th, & td": {
                      borderRight: "1px solid #ddd",
                    },
                    "& th:last-child, & td:last-child": {
                      borderRight: "none",
                    },
                  }}
                >
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#f2f2f2;" }}>
                      <TableCell
                        align="center"
                        sx={{
                          width: "60%",
                          fontWeight: 800,
                          padding: "10px 8px",
                        }}
                      >
                        Tenure
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          width: "40%",
                          fontWeight: 800,
                          padding: "10px 8px",
                        }}
                      >
                        View
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {previousCommittee.map((item, index) => (
                      <TableRow
                        key={index}
                        hover
                        sx={{
                          "&:hover td": {
                            color: "black",
                          },
                          height: "50px",
                        }}
                      >
                        <TableCell align="center" sx={{ py: 0.5 }}>
                          {item?.session}
                        </TableCell>
                        <TableCell align="center" sx={{ py: 0.5 }}>
                          <Button
                            size="small"
                            component={Link}
                            to={`${config.baseURL}${item.file}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            title={`View PDF for ward ${item?.ward_name || ""}`}
                            sx={{
                              backgroundColor: "#ED5009",
                              color: "#ffffff",
                              textTransform: "none",
                              px: 1.5,
                              py: 0.4,
                              fontSize: 12,
                              minHeight: "24px",
                              transition: "transform 0.2s ease-in-out",
                              "&:hover": {
                                backgroundColor: "#ED5009",
                                transform: "scale(1.02)",
                              },
                            }}
                          >
                            View
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          )}
          {/* End of code - Yogen on 03-06-2025
              Reason - To add for display Previous Committee Members */}
          {/* Added by - Ashlekh on 09-04-2025
          Reason - To add member registration form */}
          <div className={`${style.formTitle}`}>
            Kindly complete the form below to register as a member
          </div>
          <div className={`${style.inputBoxContainer}`}>
            <TextField
              label="Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              fullWidth
              required
              error={!!errors.name}
              helperText={errors.name}
              style={{ marginBottom: "10px" }}
            />
            <TextField
              label="Mobile Number"
              name="mobile_number"
              value={formData.mobile_number}
              onChange={handleChange}
              fullWidth
              required
              error={!!errors.mobile_number}
              helperText={errors.mobile_number}
              style={{ marginBottom: "10px" }}
            />
            <TextField
              label="Email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              fullWidth
              error={!!errors.email}
              helperText={errors.email}
              style={{ marginBottom: "10px" }}
            />
            <TextField
              label="Occupation"
              name="occupation"
              value={formData.occupation}
              onChange={handleChange}
              fullWidth
              required
              error={!!errors.occupation}
              helperText={errors.occupation}
              style={{ marginBottom: "10px" }}
            />
            {/* Added by - Ashlekh on 19-04-2025
                Reason - To add address and recommended by options */}
            <TextField
              label="Recommended by"
              name="recommended_by"
              value={formData.recommended_by}
              onChange={handleChange}
              fullWidth
              error={!!errors.recommended_by}
              helperText={errors.recommended_by}
              style={{ marginBottom: "10px" }}
            />
            <TextField
              label="Address"
              name="address"
              value={formData.address}
              onChange={handleChange}
              fullWidth
              error={!!errors.address}
              helperText={errors.address}
              style={{ marginBottom: "10px" }}
            />
            {/* End of code - Ashlekh on 19-04-2025
            Reason - To add address and recommended by options */}
            {/* <div>
              <label
                htmlFor="profile_image"
                style={{ marginBottom: "6px", fontWeight: "500" }}
              >
                Please choose an image:
              </label>
              <input
                type="file"
                id="profile_image"
                name="profile_image"
                accept="image/*"
                onChange={handleImageChange}
                style={{ marginBottom: "10px" }}
              />
              {errors.profile_image && (
                <div style={{ color: "red", fontSize: "12px" }}>
                  {errors.profile_image}
                </div>
              )}
            </div> */}
            <Button
              className={style.submitButton}
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              // fullWidth
            >
              Submit
            </Button>
          </div>
          {/* End of code - Ashlekh on 09-04-2025
          Reason - To add member registration form */}

          {/* Added by - Ashlekh on 16-05-2025
          Reason - To add downloadable member form */}
          <div className={`${style.memberFormDownloadableContainer}`}>
            <img className={`${style.downloadIcon}`} src="\download_icon.png" />
            {/* <span>Download member form</span> */}
            <span>Click here to download Membership Form</span>

            <Link
              to={`${config.baseURL}${memberForm}`}
              target="_blank"
              className={`${style.downloadButtonContainer}`}
            >
              <span className={`${style.downloadButton}`}>Download</span>
            </Link>
          </div>
          {/* End of code - Ashlekh on 16-05-2025
          Reason - To add downloadable member form */}
        </div>
      ) : (
        <div className={style.loaderContent}>
          <img style={{ height: "30vh" }} src="/adyant_loader.gif" />
        </div>
      )}
    </div>
  );
};
export default Member;
